import { render } from "./UpdateCallQueueDetailForm.vue?vue&type=template&id=2d82e584&scoped=true"
import script from "./UpdateCallQueueDetailForm.vue?vue&type=script&lang=js"
export * from "./UpdateCallQueueDetailForm.vue?vue&type=script&lang=js"

import "./UpdateCallQueueDetailForm.vue?vue&type=style&index=0&id=2d82e584&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d82e584"]])

export default __exports__